import React, { useEffect, useState } from 'react';
import { useIntl } from 'umi';
import MultipleSelector, {
  MulSelectorProps,
  SelectOptionWithGroup,
  renderImgText,
} from './MultipleSelector';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { Bubble } from 'tea-component';

interface ICountrySelectorProps extends MulSelectorProps {
  title?: string;
  options: {
    text: string;
    value: string;
  }[];
  value: string[];
  isShowIcon: boolean;
  onConfirm: (payload: string[]) => void;
  disabledMessages: string
}

export default function LanguageSelector(props: ICountrySelectorProps) {
  const { formatMessage } = useIntl();

  const {
    title = formatMessage({ id: 'dbi_countries' }),
    options: optionsOuter,
    value: valueOuter,
    onConfirm,
    disabled,
    isShowIcon = false,
    disabledMessages
  } = props;
  const options: SelectOptionWithGroup[] = (() => {
    if (!Array.isArray(optionsOuter)) return [];
    return optionsOuter.map((item) => {
      const { text, value } = item ?? {};
      const icon = getCountryFlag(value);
      return {
        value: value ?? '',
        text: isShowIcon ? renderImgText(text, icon) : text,
        label: text ?? '',
      };
    });
  })();

  const value = Array.isArray(valueOuter) ? valueOuter : [];
  return (
    <Bubble
      content={
        disabled && formatMessage({ id: disabledMessages })}
      dark
    >
      <MultipleSelector
        hasAllCheck
        searchable
        buttonName={formatMessage({ id: title })}
        options={options}
        value={value}
        onChange={onConfirm}
        disabled={disabled}
        filter={(value: string, item: any) => {
          const REG = new RegExp(value || '', 'gi'); // 模糊匹配正则
          return REG.test(item?.label);
        }}
      />
    </Bubble>
  );
}
